module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список пользователей\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), (_vm.currentUser.hasPermission('user.add')) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModalAddUser($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить пользователя\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-12 col-lg-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-6 form-control-label"
  }, [_vm._v("Имя или фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loadingUsers) ? _c('loading', {
    attrs: {
      "message": "Загружаем пользователей..."
    }
  }) : _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-12 col-lg-1 text-lg-center"
    }, [_c('div', {
      staticClass: "avatar d-none d-lg-inline"
    }, [_c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": _vm.getAvatarPath(user.avatar)
      }
    })]), _vm._v(" "), _c('div', [(user.enabled) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Активен")]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Заблокирован")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-2"
    }, [(_vm.currentUser.hasPermission('user.view.all')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ViewProfile',
          params: {
            id: user.id
          }
        }
      }
    }, [_vm._v(_vm._s(user.fullname))]) : _c('span', [_vm._v(_vm._s(user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(user.email))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-2"
    }, _vm._l((user.companies), function(company) {
      return _c('span', {
        staticClass: "badge badge-success"
      }, [_vm._v(_vm._s(company.name))])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-2"
    }, _vm._l((user.techcenters), function(techcenter, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_vm._v("\n                      " + _vm._s(techcenter.address) + "\n                    ")])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-1"
    }, [_vm._v("\n                    +7" + _vm._s(user.phone) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-1"
    }, [(user.isAdmin) ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (user.role === 'supermanager') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Менеджер")]) : _vm._e(), _vm._v(" "), (user.role === 'user') ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Пользователь")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-3"
    }, [(_vm.currentUser.hasPermission('user.block')) ? [(_vm.blockUserLoading === user.id) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : [(user.enabled) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.blockUser(user, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lock"
    }), _vm._v(" Заблокировать\n                            ")]) : _c('button', {
      staticClass: "btn btn-secondary btn-sm",
      on: {
        "click": function($event) {
          _vm.blockUser(user, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock"
    }), _vm._v(" Разблокировать\n                            ")])]] : _vm._e()], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.usersPage.paginator.total_count,
      "per-page": _vm.usersPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 col-lg-1 d-none d-lg-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-8 col-lg-2"
  }, [_vm._v("Основаная информация")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [_vm._v("Компании")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [_vm._v("Техцентры")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-1 d-none d-md-block"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 d-none d-lg-block"
  }, [_vm._v("Роль")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 d-none d-lg-block"
  }, [_vm._v("Управление")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ce68acd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2ce68acd"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Users.vue
// module id = 1019
// module chunks = 1